// extracted by mini-css-extract-plugin
export default {"component":"page_component__QEKyF","enter":"page_enter__pLEB5","enterActive":"page_enterActive__IyTwe","exit":"page_exit__nP99R","exitActive":"page_exitActive__XprKu"};